<template>
  <FormContainer without-divider>
    <template #title>Établissement et adresse d’exécution du contrat</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_7"
          :model-value="model?.employeur?.etablissement?.denomination"
          label="Dénomination"
          class="col-26 col-sm-36"
          :required="meta.employeur?.etablissement?.denomination?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.denomination?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_8"
          :model-value="model?.employeur?.etablissement?.siret?.valeur"
          label="Siret"
          class="col-10 col-sm-36"
          :required="meta.employeur?.etablissement?.siret?.valeur?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.siret?.valeur?.$messageErreurDirty!"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_16"
          :model-value="model?.employeur?.etablissement?.naf?.code"
          label="NAF"
          class="col-6 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.naf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.naf?.code?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_18"
          :model-value="model?.employeur?.etablissement?.idcc?.code"
          label="IDCC"
          class="col-6 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.idcc?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.idcc?.code?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          v-if="typePublicVisibled"
          id="field_type_public"
          :model-value="TypePublicLibelle[model?.typePublic!]"
          label="Type Public"
          class="col-6 col-md-10 col-sm-36"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_7"
          :model-value="model?.employeur?.etablissement?.adresse?.voie"
          :label="LABEL_NUMERO_VOIE"
          class="col-10 col-md-18 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.voie?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.voie?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_8"
          :model-value="model?.employeur?.etablissement?.adresse?.complement"
          label="Complément d'adresse"
          class="col-10 col-md-18 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.complement?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.complement?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_9"
          :model-value="model?.employeur?.etablissement?.adresse?.codePostal"
          label="Code postal"
          class="col-6 col-md-8 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.codePostal?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.codePostal?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_10"
          :model-value="model?.employeur?.etablissement?.adresse?.commune"
          label="Commune"
          class="col-10 col-md-18 col-sm-36"
          :required="meta.employeur?.etablissement?.adresse?.commune?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.adresse?.commune?.$messageErreurDirty!"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInputTelephone
          id="field_11"
          v-model="telephoneModel"
          label="Téléphone"
          class="col-8 col-md-10 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          :required="meta.employeur?.contact?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.contact?.telephone?.$messageErreurDirty!"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_12"
          v-model="emailModel"
          label="Email"
          class="col-12 col-md-16 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          hint="200 caractères maximum"
          :required="meta.employeur?.contact?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.contact?.email?.$messageErreurDirty!"
          deletable
          :maxlength="200"
          :readonly
          :help="emailHelp"
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_13"
          v-model="secteurEntrepriseModel"
          label="Secteur de l'entreprise"
          :items="secteurEntrepriseItems"
          :required="meta.employeur?.secteurEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.secteurEntreprise?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperDropdown
          id="field_14"
          v-model="typeEmployeurModel"
          label="Type d'employeur"
          class="col-26 col-md-22 col-sm-36"
          :items="typeEmployeurItems"
          :required="meta.employeur?.typeEmployeur?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.typeEmployeur?.$messageErreurDirty!"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_15"
          v-model="employeurSpecifiqueModel"
          label="Employeur spécifique"
          class="col-18 col-md-36 col-sm-36"
          :items="lov.EmployeurSpecifique"
          :required="meta.employeur?.employeurSpecifique?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.employeurSpecifique?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />

        <WrapperInputNumber
          id="field_17"
          v-model="effectifTotalEntrepriseModel"
          label="Effectif total de l'entreprise"
          class="col-6 col-md-16 col-sm-36"
          :required="meta.employeur?.effectifTotalEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.effectifTotalEntreprise?.$messageErreurDirty!"
          deletable
          :decimal="0"
          :separateur="true"
          :readonly
          :maxlength="6"
          :help="effectifHelp"
          :disabled="meta.employeur?.effectifTotalEntreprise?.$status === PropertyStatus.NotPresent"
        />
      </div>
      <div class="form__bloc">
        <WrapperCheckbox
          id="field_19"
          v-model="regimeSpecifiqueAssuranceChomageModel"
          label="Cochez cette case si l'apprenti adhère au régime spécifique de l'assurance chômage (ne concerne que les employeurs du secteur public)"
          :alertLabel="meta.employeur?.regimeSpecifiqueAssuranceChomage?.$messageErreurDirty!"
          :required="meta.employeur?.regimeSpecifiqueAssuranceChomage?.$status === PropertyStatus.Required"
          :readonly
          :disabled="regimeSpecifiqueAssuranceDisabled"
          class="col-36"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import type { EmployeurDTO } from '@/features/api/extranet/dto/Demande/CAPP'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { idccAutoriseTT, isAdherentOuMandatGestion } from '@/features/domaine/regles-akto/shared'
  import { TypePublicLibelle } from '@/features/domaine/types/opco'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import {
    FormContainer,
    LABEL_NUMERO_VOIE,
    PLACEHOLDER_EMAIL,
    PLACEHOLDER_TEL,
  } from '@/features/interface/demande/shared'
  import {
    secteurEntrepriseItems,
    typeEmployeurPriveItems,
    typeEmployeurPublicItems,
  } from '@/features/interface/shared/tools'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey, setupCustomUpdater } = store
  const { meta, model, lov, readonly, typeContextCourant } = storeToRefs(store)

  const telephoneModel = setupFieldWithKey<string>('employeur.contact.telephone', true)
  const emailModel = setupFieldWithKey<string>('employeur.contact.email', true)
  const regimeSpecifiqueAssuranceChomageModel = setupFieldWithKey<boolean | null>(
    'employeur.regimeSpecifiqueAssuranceChomage',
  )
  const effectifTotalEntrepriseModel = setupFieldWithKey<number>('employeur.effectifTotalEntreprise', true)
  const secteurEntrepriseModel = setupFieldWithKey<string>('employeur.secteurEntreprise', false)
  const typeEmployeurModel = setupFieldWithKey<string | null>('employeur.typeEmployeur', false)
  const employeurSpecifiqueModel = setupFieldWithKey<string>('employeur.employeurSpecifique', false)

  const typeEmployeurItems = computed(() => {
    if (model.value?.employeur?.secteurEntreprise === 'Public') {
      return typeEmployeurPublicItems
    } else if (model.value?.employeur?.secteurEntreprise === 'Prive') {
      return typeEmployeurPriveItems
    } else {
      return [...typeEmployeurPriveItems, ...typeEmployeurPublicItems]
    }
  })

  const regimeSpecifiqueAssuranceDisabled = computed(() => {
    return model.value?.employeur?.secteurEntreprise === 'Prive'
  })

  const typePublicVisibled = computed(() => {
    return idccAutoriseTT.includes(model.value?.employeur?.etablissement?.idcc?.code ?? '')
  })

  const updateEmplyeur = setupCustomUpdater<EmployeurDTO | null>((patch, value) => {
    patch.employeur!.regimeSpecifiqueAssuranceChomage = value!.regimeSpecifiqueAssuranceChomage
    patch.employeur!.typeEmployeur = value!.typeEmployeur
  })

  watch(
    () => model?.value?.employeur?.secteurEntreprise,
    () => {
      let typeEmployeur: string | null | undefined = model.value?.employeur?.typeEmployeur
      let regimeSpecifiqueAssuranceChomage: boolean | null | undefined =
        model.value?.employeur?.regimeSpecifiqueAssuranceChomage

      if (model.value?.employeur?.secteurEntreprise === 'Prive') regimeSpecifiqueAssuranceChomage = null

      if (model?.value?.employeur?.secteurEntreprise) {
        const typeEmployeurItems =
          model.value?.employeur?.secteurEntreprise === 'Public' ? typeEmployeurPublicItems : typeEmployeurPriveItems

        if (!typeEmployeurItems.some((x) => x.id === model?.value?.employeur?.typeEmployeur)) typeEmployeur = null
      }

      updateEmplyeur({
        regimeSpecifiqueAssuranceChomage: regimeSpecifiqueAssuranceChomage,
        typeEmployeur: typeEmployeur,
      } as any)
    },
  )

  const emailHelp = computed(() => {
    return typeContextCourant.value === TypesContextesAutorisesEnum.Adherent
      ? "Renseigner ici votre Email ou l'email indiqué dans le CERFA"
      : 'Renseigner ici l’Email de l’employeur ou à défaut l’Email de votre contact entreprise'
  })

  const effectifHelp = computed(() => {
    return isAdherentOuMandatGestion(typeContextCourant.value, model.value?.estSousMandatGestion)
      ? "L'effectif complet de tous les établissements confondus. Attention ce nombre aura un impact sur le versement des aides de l'état"
      : undefined
  })
</script>
